// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"e9293765","393":"dc4ef62e","447":"b771b3b7","967":"7dc1e8cc"}[chunkId] + ".chunk.js";
};